// import Card from '@/components/Card/Card.vue';
import ObjectTypesSidebar from '@/views/Brand/ObjectTypes/ObjectTypesSidebar.vue';
// import FetchData from '@/components/DataProvider/FetchData.vue';
// import IconSpinner from '@/components/Icon/icons/IconSpinner.vue';
// import Pagination from '@/components/Pagination/Pagination.vue';
// import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
// import FilterToggler from '@/components/Filters/FilterToggler.vue';
import { PortalTarget } from '@/constants/portal';
// import { mapQueryToApiV2 } from '@/util/query';
import { defineComponent } from '@vue/composition-api';
// import {
//   ObjectTypeDto,
//   ObjectTypeQuery,
//   ObjectTypeStatus,
// } from '@/api/v2/requests/objects';
// import { useRouteQuery } from '@/composables';
import { FILTER_DEBOUNCE } from '@/constants/filters';
// import { DEFAULT_CARD_LIMIT } from '@/constants/pagination';
// import { PaginatedResponse } from '@/api/v2/requests/types';
import ContentWrapper from '@/layouts/BrandLayout/Components/ContentWrapper.vue';
import CentralCosts from '@/views/Brand/CentralCosts/CentralCosts.vue';
export default defineComponent({
    name: 'ObjectTypes',
    components: {
        // Card,
        ObjectTypesSidebar,
        // FetchData,
        // IconSpinner,
        // Pagination,
        // Breadcrumbs,
        // FilterToggler,
        ContentWrapper,
        CentralCosts,
    },
    setup() {
        // const objectTypesList = ref<ObjectTypeDto[]>([]);
        // const lastPage = ref(0);
        // const { routeQuery, changePage } = useRouteQuery(ctx);
        // const computedQuery = computed<ObjectTypeQuery>(() => {
        //   const { q, ...query } = mapQueryToApiV2(routeQuery.value);
        //   return {
        //     ...query,
        //     name: q,
        //     status: ObjectTypeStatus.ACTIVE,
        //     perPage: query.perPage || DEFAULT_CARD_LIMIT,
        //     page:
        //       typeof query.page === 'string'
        //         ? parseInt(query.page, 10)
        //         : query.page ?? 1,
        //   };
        // });
        // const currentPage = computed(() => {
        //   return computedQuery.value?.page ?? 1;
        // });
        // const updateList = (data: PaginatedResponse<ObjectTypeDto>) => {
        //   objectTypesList.value = data.nodes;
        //   lastPage.value = Math.ceil(
        //     data.totalCount / (computedQuery.value?.perPage || DEFAULT_CARD_LIMIT),
        //   );
        // };
        // const shouldHideSizeInSrc = (objectType: ObjectTypeDto) => {
        //   return objectType.logoUrl?.includes('?size=');
        // };
        return {
            PortalTarget,
            FILTER_DEBOUNCE,
        };
    },
});
